module.exports = __webpack_public_path__ + "static/media/presta_service.0b324da2.png";